import useSEO, { SEO_CONFIG } from '@/hooks/useSEO';

export default function LegalMentions() {
  useSEO(SEO_CONFIG.legalMentions);
  
  return (
    <div className="py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl font-heading text-primary mb-12">Mentions légales</h1>
        
        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-3xl font-heading text-foreground mb-4">Éditeur du site</h2>
            <p>
              <strong>Soif de Provence</strong><br />
              Denis BONNELY<br />
              Brasserie artisanale<br />
              1688 petite route des Jardins<br />
              13210 Saint-Rémy-de-Provence<br />
              France<br />
              <br />
              Téléphone : <a href="tel:+33664822759" className="text-accent hover:text-accent/80">06 64 82 27 59</a><br />
              Email : <a href="mailto:soifdeprovence@gmail.com" className="text-accent hover:text-accent/80">soifdeprovence@gmail.com</a><br />
              <br />
              <a 
                href="https://maps.google.com/?q=1688+petite+route+des+Jardins,+13210+Saint-Rémy-de-Provence,+France" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-accent hover:text-accent/80"
              >
                📍 Voir sur Google Maps
              </a><br />
              <br />
              SIRET : [À compléter]<br />
              N° TVA intracommunautaire : [À compléter]
            </p>
          </section>
          
          <section>
            <h2 className="text-3xl font-heading text-primary mb-4">Directeur de publication</h2>
            <p>[Nom du directeur de publication]</p>
          </section>
          
          <section>
            <h2 className="text-3xl font-heading text-primary mb-4">Hébergement</h2>
            <p>
              Ce site est hébergé par :<br />
              [Nom de l'hébergeur]<br />
              [Adresse complète]<br />
              Téléphone : [Numéro]
            </p>
          </section>
          
          <section>
            <h2 className="text-3xl font-heading text-primary mb-4">Propriété intellectuelle</h2>
            <p>
              L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
            </p>
          </section>
          
          <section>
            <h2 className="text-3xl font-heading text-primary mb-4">Consommation d'alcool</h2>
            <p className="font-semibold">
              L'abus d'alcool est dangereux pour la santé, à consommer avec modération.<br />
              La vente d'alcool est interdite aux mineurs de moins de 18 ans.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}